import React, { useRef } from "react";
import { Image as ImageIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ImageUploadButtonProps {
  className?: string;
  id?: string;
  onImageSelected?: (imageUrl: string, fileName: string) => void;
}

export const ImageUploadButton: React.FC<ImageUploadButtonProps> = ({
  className,
  id,
  onImageSelected,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Create a URL for the uploaded image
    const imageUrl = URL.createObjectURL(file);

    // In a real implementation, we would use the Plate.js API to insert the image
    // For now, we'll just log the image URL and call the onImageSelected callback if provided
    console.log("Image URL:", imageUrl);
    console.log("Image alt:", file.name);

    // Call the callback if provided
    if (onImageSelected) {
      onImageSelected(imageUrl, file.name);
    }

    // Reset the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleButtonClick}
        className={`h-8 w-8 p-0 ${className || ""}`}
      >
        <ImageIcon className="h-4 w-4" />
      </Button>
      <input
        type="file"
        ref={fileInputRef}
        id={id}
        onChange={handleFileChange}
        accept="image/*"
        className="hidden"
      />
    </>
  );
};
